import React, {useEffect} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {Box, Typography, Stack, Breadcrumbs} from '@mui/material';
import { useDarkMode } from '../darkMode/hook/useDarkMode';
import { useFAQ } from './hooks/useFAQ';
import {withNavigation} from "../navigation/navigation";
import {withFaqContext} from "./state/faqContext";


const FAQList = () => {
  const { mode } = useDarkMode();
  const { faqs, loading } = useFAQ();
  const navigate = useNavigate();

useEffect(() => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}, []);

const breadcrumbs = [
    <Typography
        className={'breadcrumbs'}
        variant={'body2'}
        onClick={() => navigate('/')}
        style={{color: mode.settings.breadcrumbColor1}}>
        Accueil
    </Typography>,
    <Typography variant={'body2'} style={{color: mode.settings.textColor3}}>
        Foire aux questions
    </Typography>,
];

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  return (
      <Stack style={{marginTop : '15px'}} width={'100%'}>
          <Breadcrumbs
              separator="›"
              aria-label="navigation"
              style={{color: mode.settings.textColor3, marginBottom: '15px'}}>
              {breadcrumbs}
          </Breadcrumbs>
          <Box style={{
              alignSelf: 'flex-start',
              width: '100%',
              flexGrow: 1,
              backgroundColor: mode.settings.cardBackgroundColor,
              padding: 15
          }}
          >
              <Typography variant="h3" sx={{ color: mode.settings.textColor3, marginBottom : 3 }}>
                  Foire aux questions
              </Typography>
              <Stack spacing={2} sx={{marginLeft : 3}}>
                  {faqs.map(faq => (
                      <Link key={faq.id} to={`/faq/${faq.id}`} style={{ textDecoration: 'none' }}>
                          <Typography variant="h4" sx={{ color: mode.settings.textColor3 }}>
                              {faq.question}
                          </Typography>
                      </Link>
                  ))}
              </Stack>
          </Box>
      </Stack>

  );
};

export default withFaqContext(withNavigation(FAQList));